import { FontAwesomeIcon } from '@appcharge/shared-ui';

interface PageInactiveBannerProps {
  message: string;
  linkText?: string;
  linkUrl?: string;
}

const PageInactiveBanner: React.FC<PageInactiveBannerProps> = ({
  message,
  linkText,
  linkUrl
}) => {
  return (
    <div className="flex items-center justify-between gap-4 rounded-md bg-indigo-50 px-4 h-[42px]">
      <div className="flex items-center gap-2">
        <FontAwesomeIcon
          icon="fa-regular fa-lock"
          className="text-base-sidebarForeground text-sm"
        />
        <div className="flex items-center gap-2 text-sm text-gray-700">
          <span className="font-semibold">Page Inactive</span>
          <span className="text-gray-400">|</span>
          <span>{message}</span>
        </div>
      </div>
      {linkText && linkUrl && (
        <a
          href={linkUrl}
          className="flex items-center gap-2 px-3 h-7 text-sm font-medium text-gray-700 bg-white rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap"
        >
          {linkText}
          <FontAwesomeIcon icon="fa-solid fa-arrow-up-right" className="text-xs" />
        </a>
      )}
    </div>
  );
};

export default PageInactiveBanner;

